import { render } from "./GroupChatPage.vue?vue&type=template&id=fdc6c7c2&scoped=true"
import script from "./GroupChatPage.vue?vue&type=script&lang=js"
export * from "./GroupChatPage.vue?vue&type=script&lang=js"

import "./GroupChatPage.vue?vue&type=style&index=0&id=fdc6c7c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdc6c7c2"]])

export default __exports__